import React from "react";

const CreateConfig = () => {
  return <div>CreateConfig</div>;
};

export default CreateConfig;
